export default {
  name: "platform",
};
